import {
    IAffectedPositionsByTransactionIdParams,
    IServiceHistoryAccountLevelPositionsGetQuery,
    IServiceHistoryPositionsGetQuery,
    IServicePositionLotPostBody,
    ListResult,
} from '@shared/api';
import { Api } from '../../Api';
import { IAffectedPositions, IServiceAccountLevelPositionsDto, IServiceBrokerLevelPositionsDto } from './interfaces';
import { ISettingsPositionsGetQuery } from './query';

export class Positions {
    private static _basePath = '/PositionLot';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${Positions._basePath}`;
        return {
            async get(query: ISettingsPositionsGetQuery) {
                const path = '/';
                return await Api.get<ListResult<IServiceAccountLevelPositionsDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getHistory(query: IServiceHistoryAccountLevelPositionsGetQuery) {
                const path = '/history';
                return await Api.get<ListResult<IServiceAccountLevelPositionsDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getBrokerLevel(query: ISettingsPositionsGetQuery) {
                const path = '/broker-level';
                return await Api.get<ListResult<IServiceBrokerLevelPositionsDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },

            async getBrokerLevelClient(query: ISettingsPositionsGetQuery) {
                const path = '/broker-level-client';
                return await Api.get<ListResult<IServiceBrokerLevelPositionsDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },

            async getAllBrokerLevelSecurities() {
                const path = '/all-broker-level';
                return await Api.get<IServiceBrokerLevelPositionsDto[]>({
                    path: `${basePath}${path}`,
                });
            },

            async getAssignedPosition(query: ISettingsPositionsGetQuery) {
                const path = '/getAssignedPosition';
                return await Api.get<ListResult<any>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },

            async getBrokerLevelHistory(query: IServiceHistoryPositionsGetQuery) {
                const path = '/broker-level/history';
                return await Api.get<ListResult<IServiceBrokerLevelPositionsDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getAffectedPositions({ transactionId }: IAffectedPositionsByTransactionIdParams) {
                const path = `/transactions/${transactionId}/sequence`;
                return await Api.get<IAffectedPositions>({
                    path: `${basePath}${path}`,
                });
            },
            async putById(body: IServiceAccountLevelPositionsDto) {
                const path = '/';
                return await Api.put<void>({
                    path: `${basePath}${path}`,
                    body,
                });
            },
            async postPositionLot(body: IServicePositionLotPostBody) {
                const path = '/';
                return await Api.post<void>({
                    path: `${basePath}${path}`,
                    body,
                });
            },

            async getMyPortfolioAsync(query: ISettingsPositionsGetQuery) {
                const path = '/';
                return await Api.get<ListResult<any>>({
                    path: `${parentPath}/AssignedSecurities${path}`,
                    query,
                });
            },
        };
    }
}
